export default "__VITE_ASSET__o054irQl__"